import { Navigate, Outlet } from "react-router-dom"
import { useAuthContext } from "./authContext"

const PrivateRoute = ({ component: Component, ...rest }: any) => {
    const { currentUser } = useAuthContext()
    return currentUser ? <Outlet /> : <Navigate to="/" />
}

export { PrivateRoute }